// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  background-color: #DDE8B9;
  font-family: 'Staatliches', sans-serif;
}

/* Layout Wrapper */
.terminal-wrapper {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
}

.terminal-title {
  text-align: center;
  font-size: 4.5rem;
  color: #648202;
  font-family: 'Staatliches', sans-serif;
  margin-top: 1rem;
  margin-bottom: 2rem;
  text-transform: uppercase;
  letter-spacing: 3px;
}

.area-container {
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
  justify-content: center;
  padding: 1rem;
  width: 100%;
  max-width: 1000px;
}

/* Karte */
.area-card {
  background-color: #ccc;
  border-radius: 40px;
  padding: 2.5rem;
  color: white;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: auto;
  min-height: 380px;
  width: 100%;
  max-width: 380px;
  font-weight: normal;
  border: 4px solid rgba(255, 255, 255, 0.4);
  position: relative;
  overflow: hidden;
}

/* Shine effect */
.area-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0) 100%);
  transform: skewX(-25deg);
  transition: all 0.6s ease;
}

.area-card:active::after {
  left: 200%;
  transition: all 0.2s ease;
}

/* Touch (Klick) Effekt */
.area-card:active {
  transform: scale(0.98);
  border-color: rgba(255, 255, 255, 0.8);
}

.area-icon {
  font-size: 8rem !important;
  margin-bottom: 1.5rem;
  transition: transform 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.area-card:active .area-icon {
  transform: scale(1.05) rotate(5deg);
}

/* Farben für einzelne Bereiche */
.area-card.arbeit {
  background: linear-gradient(135deg, #fbc651 0%, #F4AF20 100%);
}

.area-card.freizeit {
  background: linear-gradient(135deg, #f57a52 0%, #ee5522 100%);
}

.area-card.listen {
  background: linear-gradient(135deg, #339ce6 0%, #0077c8 100%);
}

/* Login Screen */
.login-screen {
  height: 100vh;
  background-color: #DDE8B9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-screen form {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}

.login-screen input {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid #aaa;
  font-family: 'Circular', sans-serif;
}

.login-screen button {
  background-color: #648202;
  color: #FFFFFF;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: normal;
  font-family: 'Circular', sans-serif;
  text-transform: uppercase;
}

.login-screen button:hover {
  background-color: #5a7502;
}

.area-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  width: 100%;
  font-weight: normal;
  z-index: 1;
}

.area-content h2 {
  font-size: 2.8rem;
  font-family: 'Staatliches', sans-serif;
  margin: 0 0 1rem 0;
  text-transform: uppercase;
  color: white;
  text-align: center;
  font-weight: normal;
  letter-spacing: 1px;
}

/* Beschreibung */
.area-content p {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.95);
  line-height: 1.4;
  margin: 0;
  text-align: center !important;
  font-weight: normal;
  font-family: 'Circular', sans-serif;
  text-transform: none;
}

.footer-link {
  text-align: center;
  margin-top: 3rem;
  font-size: 1.2rem;
}

.footer-link a {
  color: #648202;
  text-decoration: underline;
  text-underline-offset: 4px;
  font-weight: bold;
  font-family: 'Circular', sans-serif;
  transition: color 0.2s ease;
}

.footer-link a:hover {
  color: #F4AF20;
}

@media (max-width: 768px) {
  .area-container {
    gap: 1.5rem;
  }
  .terminal-title {
    font-size: 3rem;
  }
  .area-icon {
    font-size: 6rem !important;
  }
}

@media (max-width: 480px) {
  .area-card {
    min-height: 300px;
    border-radius: 30px;
    padding: 1.5rem;
  }

  .area-icon {
    font-size: 5rem !important;
  }
  
  .area-content h2 {
    font-size: 2rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Terminal.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kHAAkH;EAClH,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;EACE,mCAAmC;AACrC;;AAEA,iCAAiC;AACjC;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;EACnB,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;EACjB,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  background-color: #DDE8B9;\n  font-family: 'Staatliches', sans-serif;\n}\n\n/* Layout Wrapper */\n.terminal-wrapper {\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 100vh;\n}\n\n.terminal-title {\n  text-align: center;\n  font-size: 4.5rem;\n  color: #648202;\n  font-family: 'Staatliches', sans-serif;\n  margin-top: 1rem;\n  margin-bottom: 2rem;\n  text-transform: uppercase;\n  letter-spacing: 3px;\n}\n\n.area-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3rem;\n  justify-content: center;\n  padding: 1rem;\n  width: 100%;\n  max-width: 1000px;\n}\n\n/* Karte */\n.area-card {\n  background-color: #ccc;\n  border-radius: 40px;\n  padding: 2.5rem;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  height: auto;\n  min-height: 380px;\n  width: 100%;\n  max-width: 380px;\n  font-weight: normal;\n  border: 4px solid rgba(255, 255, 255, 0.4);\n  position: relative;\n  overflow: hidden;\n}\n\n/* Shine effect */\n.area-card::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0) 100%);\n  transform: skewX(-25deg);\n  transition: all 0.6s ease;\n}\n\n.area-card:active::after {\n  left: 200%;\n  transition: all 0.2s ease;\n}\n\n/* Touch (Klick) Effekt */\n.area-card:active {\n  transform: scale(0.98);\n  border-color: rgba(255, 255, 255, 0.8);\n}\n\n.area-icon {\n  font-size: 8rem !important;\n  margin-bottom: 1.5rem;\n  transition: transform 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n.area-card:active .area-icon {\n  transform: scale(1.05) rotate(5deg);\n}\n\n/* Farben für einzelne Bereiche */\n.area-card.arbeit {\n  background: linear-gradient(135deg, #fbc651 0%, #F4AF20 100%);\n}\n\n.area-card.freizeit {\n  background: linear-gradient(135deg, #f57a52 0%, #ee5522 100%);\n}\n\n.area-card.listen {\n  background: linear-gradient(135deg, #339ce6 0%, #0077c8 100%);\n}\n\n/* Login Screen */\n.login-screen {\n  height: 100vh;\n  background-color: #DDE8B9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-screen form {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n}\n\n.login-screen input {\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n  padding: 0.5rem;\n  border-radius: 6px;\n  border: 1px solid #aaa;\n  font-family: 'Circular', sans-serif;\n}\n\n.login-screen button {\n  background-color: #648202;\n  color: #FFFFFF;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: normal;\n  font-family: 'Circular', sans-serif;\n  text-transform: uppercase;\n}\n\n.login-screen button:hover {\n  background-color: #5a7502;\n}\n\n.area-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex-grow: 1;\n  width: 100%;\n  font-weight: normal;\n  z-index: 1;\n}\n\n.area-content h2 {\n  font-size: 2.8rem;\n  font-family: 'Staatliches', sans-serif;\n  margin: 0 0 1rem 0;\n  text-transform: uppercase;\n  color: white;\n  text-align: center;\n  font-weight: normal;\n  letter-spacing: 1px;\n}\n\n/* Beschreibung */\n.area-content p {\n  font-size: 1.25rem;\n  color: rgba(255, 255, 255, 0.95);\n  line-height: 1.4;\n  margin: 0;\n  text-align: center !important;\n  font-weight: normal;\n  font-family: 'Circular', sans-serif;\n  text-transform: none;\n}\n\n.footer-link {\n  text-align: center;\n  margin-top: 3rem;\n  font-size: 1.2rem;\n}\n\n.footer-link a {\n  color: #648202;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n  font-weight: bold;\n  font-family: 'Circular', sans-serif;\n  transition: color 0.2s ease;\n}\n\n.footer-link a:hover {\n  color: #F4AF20;\n}\n\n@media (max-width: 768px) {\n  .area-container {\n    gap: 1.5rem;\n  }\n  .terminal-title {\n    font-size: 3rem;\n  }\n  .area-icon {\n    font-size: 6rem !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .area-card {\n    min-height: 300px;\n    border-radius: 30px;\n    padding: 1.5rem;\n  }\n\n  .area-icon {\n    font-size: 5rem !important;\n  }\n  \n  .area-content h2 {\n    font-size: 2rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
